import React, {Component} from 'react';
import Navigator from './Navigator.js';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {LittleEndian, AsmGraphics} from './Graphics.js';
import ReactMarkdown from 'react-markdown'

class Ctf extends Component {
	constructor(props){
		super(props)
		this.state = {}
	}
	componentDidMount(){
		for(let write_up of this.props.write_ups){
			fetch(write_up.path)
				.then(res => res.text())
				.then(text => {
					this.setState({
						[write_up.name]: text
					})
				})
		}
	}

	render(){
		return(
			<section id={this.props.name.replace(/ /g,'')}>
				<h2>{this.props.name}</h2>
				<div className="terminal-timeline">
					{
						this.props.write_ups.map((write_up) => {
							return (
								<div className="terminal-card" key={write_up.name} id={this.props.name.replace(/ /g,'')+write_up.name}>
									<header><strong>{write_up.name} - {write_up.category}</strong></header>
									<div>
										{
											this.state[write_up.name] ? (<ReactMarkdown>{this.state[write_up.name]}</ReactMarkdown>) : ("")
										}
									</div>
								</div>
							)
						})
					}
					
				</div>
			</section>
		)
	}
}

class Writeups extends Component{
	constructor(props){
		super(props)
		this.state = {
			width: 0,
			height: 0
		}
		this.updateWindowDims = this.updateWindowDims.bind(this)
		this.writeup_data = [
			{
				ctf_name: "US Cyber Open - Season II",
				write_ups: [
					{
						name: "well-ordered",
						path: "/assets/uscg-2022/well-ordered/writeup.md",
						category: "RE"
					}
				]
			},
			{
				ctf_name: "Tenable CTF 2021",
				write_ups: [
					{
						name: "Play Me",
						path: "/assets/tenable-2021/playme/writeup.md",
						category: "Vidya"
					},
					{
						name: "Fix me",
						path: "/assets/tenable-2021/Fixme/writeup.md",
						category: "Forensics"
					},
					{
						name: "ECDSA Implementation Review",
						path: "/assets/tenable-2021/ECDSA/writeup.md",
						category: "Crypto"
					},
					{
						name: "Netrunner Encryption",
						path: "/assets/tenable-2021/net_runner/writeup.md",
						category: "Crypto"
					}
				]
			},
			{
				ctf_name: "Tokyo Western 2020",
				write_ups:[
					{
						name:"reversing is amazing",
						path:"/assets/tokyo_western_2020/reverseing_is_amazing/writeup.md",
						category: "RE"
					}
				]
			},
			{
				ctf_name: "CSAW 2020",
				write_ups: [
					{
						name: "flask_caching",
						path: "/assets/csaw-2020/flask_caching/writeup.md",
						category: "Web"
					},
					{
						name: "modus_operandi",
						path: "/assets/csaw-2020/modus_operandi/writeup.md",
						category: "Crypto"
					}
				]
			},
			{
				ctf_name: "MetaCTF 2018",
				write_ups: [
					{
						name: "3D Secrets",
						path: "/assets/metactf_2018/3dsecrets/writeup.md",
						category: "Forensics"
					},
					{
						name: "Repeated Locks",
						path: "/assets/metactf_2018/repeated_locks/writeup.md",
						category: "Crypto"
					}
				]
			},
			{
				ctf_name: "UMD CTF 2018",
				write_ups:[
					{
						name:"Ogre",
						path:"/assets/umdctf_2018/Ogre/writeup.md",
						category: "Forensics"
					}
				]
			},
			{
				ctf_name: "IceCTF 2016",
				write_ups:[
					{
						name:"Over the Hill",
						path:"/assets/icectf_2016/writeup.md",
						category: "Crypto"
					}
				]
			},
			{
				ctf_name: "Hack UCF",
				write_ups: [
					{
						name: "arm1",
						path: "/assets/hackucf/arm1/writeup.md",
						category: "Forensics"
					},
					{
						name: "Fleas",
						path: "/assets/hackucf/Fleas/writeup.md",
						category: "Crypto"
					}
				]
			}
		]
	}

	updateWindowDims() {
		const {innerWidth: width, innerHeight:height} = window;
		this.setState({
			width: width,
			height: height
		})
	}

	componentDidMount(){
		this.updateWindowDims()
		window.addEventListener('resize', this.updateWindowDims)
	}

	componentWillUnmount(){
		window.removeEventListener('resize', this.updateWindowDims)
	}

	render(){
		let toc_style = {}
		if (this.state.width <= 991){
			toc_style = {postion:'default'}
		}else{
			toc_style = {position:'fixed', width:"12em"}
		}
		
		return(
			<div className="container">
				<Navigator/>
				<Grid>
					<Row>
						<Col sm={12} md={2}>
							<aside id="menu" style={toc_style} className="TOC">
								<h2>Table of Contents</h2>
								<nav>
									<ul>
										{
											this.writeup_data.map((ctf, idx) => {
												return(
													<li key={idx}>
														<a href={`#${ctf.ctf_name.replace(/ /g,'')}`}>{ctf.ctf_name}</a>
														<ul>
															{
																ctf.write_ups.map((write_up, idx2) => {
																	return(
																		<li key={idx2}><a href={`#${ctf.ctf_name.replace(/ /g,'')+write_up.name}`}>- {write_up.name}</a></li>
																	)
																})
															}
														</ul>
													</li>
												)
											})
										}
									</ul>
								</nav>
							</aside>
						</Col>
						<Col sm={12} md={10}>
						<main>
							<section>
								<h2><LittleEndian>CTF Write Ups</LittleEndian></h2>
								<p>These are my CTF Write Ups.</p>
							</section>
							<hr/>
							{
								this.writeup_data.map((ctf) => {
									return(
										<Ctf name={ctf.ctf_name} write_ups={ctf.write_ups} key={ctf.ctf_name}/>
									)
								})
							}
							<hr/>
						</main>
						</Col>
					</Row>
				</Grid>
				
				
			</div>
		);
	}
}

class MyProblems extends Component{
	render(){
		return(
			<div className="container">
				<Navigator/>
				<main>
					<section>
						<p>I make CTF challenges occasionally. These are writeups by others who've solved my challenges</p>
					</section>
					<hr/>
					<ul>
						<li>
							Patriot CTF 2020
							<ul>
								<li><a href="https://bannsec.github.io/writeups/2020/04/28/patriotctf-2020-rev-constrained-hearts/">Constrained Hearts</a></li>
								<li><a href="https://bannsec.github.io/writeups/2020/04/30/patriotctf-2020-pwn-third-time/">Third Time</a></li>
							</ul>
						</li>

						
					</ul>
				</main>
			</div>
		)
	}
}

class CtfIndex extends Component{
	render(){
		return(
			<div className="container">
				<Navigator/>
				<main>
					<section>
							<header><h1><LittleEndian>Capture The Flag</LittleEndian></h1></header>
							<AsmGraphics/>
							<p>
								Here, you can find write ups for both challenges I've completed and write ups other people have written for challenges I've created
							</p>
					</section>
					<hr/>
					<section>
						<ul>
							<li><a href="/ctf/writeups">Write Ups of challenges I've completed</a></li>
							<li><a href="/ctf/problems">Write Ups of challenges I've authored</a></li>
						</ul>
					</section>
				</main>
			</div>
		)
	}
}

export {CtfIndex, Writeups, MyProblems}
